import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=2667d97e&scoped=true&"
import script from "./Code.vue?vue&type=script&lang=ts&"
export * from "./Code.vue?vue&type=script&lang=ts&"
import style0 from "./Code.vue?vue&type=style&index=0&id=2667d97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2667d97e",
  null
  
)

export default component.exports